import {Component, inject, Type} from '@angular/core';
import { BaseModalComponent } from "../base-modal/base-modal.component";
import {
  ChartMapType,
  LineChartComponentInputs,
  LineChartDialogData,
  UpdateLineChartParams
} from "./types/line-chart-modal.types";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { MatButton } from "@angular/material/button";
import {defaultUpdateLineChartParams, lineChartModalName} from "./configs/line-chart-modal-config";
import {LineChartDayComponent} from "./components/line-chart-day/line-chart-day.component";
import {LineChartWeekComponent} from "./components/line-chart-week/line-chart-week.component";
import {LineChartMonthComponent} from "./components/line-chart-month/line-chart-month.component";
import {LineChartModalService} from "./services/line-chart-modal.service";
import {NgComponentOutlet} from "@angular/common";
import {LineChartFiltersComponent} from "./components/line-chart-filters/line-chart-filters.component";
import {LoaderComponent} from "../../../../shared/components/loader/loader.component";

@Component({
  selector: 'app-line-chart-modal',
  imports: [
    BaseModalComponent,
    FormsModule,
    MatButton,
    ReactiveFormsModule,
    NgComponentOutlet,
    LineChartFiltersComponent,
    LoaderComponent
  ],
  templateUrl: './line-chart-modal.component.html',
  styleUrl: './line-chart-modal.component.scss'
})
export class LineChartModalComponent extends BaseModalComponent {
  public lineChartDialogData = inject<LineChartDialogData>(MAT_DIALOG_DATA);
  private lineChartModalService: LineChartModalService = inject(LineChartModalService);

  public updateLineChartParams: UpdateLineChartParams = defaultUpdateLineChartParams;
  public readonly chartComponentMap: Record<ChartMapType, Type<LineChartComponentInputs>> = {
    day: LineChartDayComponent,
    week: LineChartWeekComponent,
    month: LineChartMonthComponent
  };
  public isArticlePage: boolean = false;

  public get chartComponent(): Type<LineChartComponentInputs> | null {
    const chartType =  this.lineChartModalService.getChartType(this.lineChartDialogData?.parentUrl);
    if (!chartType) { return null; }

    return this.chartComponentMap[chartType];
  }

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(lineChartModalName);
    this.isArticlePage = this.lineChartDialogData.parentUrl.includes('article');
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(lineChartModalName);
  }

  public updateChart(updateLineChartParams: UpdateLineChartParams): void {
    this.loadingService.setIsLoadingState(true);
    this.updateLineChartParams = updateLineChartParams;
    this.loadingService.setIsLoadingState(false);
  }
}
